import { useMutation, useQuery } from '@tanstack/react-query'

import { getSurveyExecution } from 'services/glass-api/surveyExecutions'
import { minutesToMs } from 'utils/general'
import { submitAnswers } from 'services/glass-api/surveys'

export function useSubmitAnswers({ retry }: { retry: number }) {
  return useMutation({ mutationFn: submitAnswers, retry })
}

export function useSurvey({ surveyHash }: { surveyHash: string | undefined }) {
  return useQuery({
    enabled: !!surveyHash,
    queryFn: () => {
      if (!surveyHash) {
        throw new Error('No survey hash provided')
      }

      return getSurveyExecution({ surveyHash })
    },
    queryKey: ['surveys', surveyHash],
    staleTime: minutesToMs(5),
  })
}
